import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-review",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-shipping-cost",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-coupon",
    element: <ArticlePage />,
  },
  {
    path: "/is-allchinabuy-legit",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-warehouse",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-qc-guide",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-beginner-guide",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;